import React, { useReducer, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../lib/ep';

import ActionLink from '../components/builder/ActionLink';
import Checkbox from '../components/builder/Checkbox';
import { DynamicForm } from '../components/builder/DynamicForm';
import EmailField from '../components/builder/EmailField';
import Input from '../components/builder/Input';
import Model from '../components/builder/Model';
import PhoneField, { singlePhone } from '../components/builder/PhoneField';
import SaveButton from '../components/builder/SaveButton';

import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText';
import FloatingLayerPublic from '../components/front/FloatingLayerPublic';

const Wrapper = (props) => {
	const image = props?.image ?? false;
	const description = props?.description ?? false;

	return (
		<div class="flex_cols">
			{(image !== false) && (
				<div class="flex_col col_1">
					<div class="register_media_flex">
						<img src={image} style={{maxWidth:'100%'}} />
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<div class="register_form_flex" style={{width:'100%'}}>
					{(description !== false && description != "") && (
						<LeveledHTMLText
							_class={{ other:'gui_main_text_color_on_bg' }}
						>{description}</LeveledHTMLText>
					)}

					<article>
						{props.children}
					</article>
				</div>
			</div>
		</div>
	)
};

const ClaimPromoLive = (props) => {
	const prize = props?.prize ?? false;
	const promotion = props?.promotion?.Promotion ?? false;

	if(prize === false || promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const prize_type = prize?.PrizeType ?? {};
	const user = prize?.User ?? {};
	
	const [ state, dispatch ] = useReducer(( state, action ) => {
		switch (action.type) {
			case 'NO_PRIZES':
				return { ...state, status:'no_prize' };

			case 'CHECKING':
				return { ...state, status:'checking' };

			case 'MAIL_SENT':
				return { ...state, status:'mail_sent' };

			case 'SET_PRIZES':
				return { ...state, prizes:action.prizes, status:'prize_list' };
		
			case 'CLAIM_FORM':
				return { ...state, prize:action.prize, status:'claim_form' };

			case 'SET_ERRORS':
				return {...state,errors:action.errors};

			case 'SET_USER_FORM':
				let new_form = { ...state.form, ...action.user };
				for(var i in new_form) {
					if(new_form[i] == '') delete new_form[i];
				}

				return { ...state, form:new_form, is_valid:action.is_valid };

			case 'SET_USER_ERROR':
				if (state.user_errors === false) state.user_errors = {};
				return {...state,user_errors:{...state.user_errors,[action.k]:action.v}}

			case 'CHANGE_USER':
				if (state.user_errors[action.k]!= undefined) delete state.user_errors[action.k];
				return {
					...state,
					user:{
						...state.user,
						[action.k]:action.v,
					},
					user_errors:{...state.user_errors}
				};

			case 'TOGGLE_ERRORS':
				return { ...state, showFormErrors:!state.showFormErrors };

			case 'SHOW_ERRORS':
				return { ...state, showFormErrors:true };

			case 'SET_CLAIMED':
				return { ...state, status:'thanks' };
			
			default:
				return state;
		}
	}, {
		status:(props.claim != false && props.claim.PromoClaim.status != '0') ? 'claimed' : 'landing',
		prizes:[],
		prize:props.prize,
		form:null,
		user:{
			first_name:user.first_name,
			last_name:user.last_name,
			email:user.email,
			phone:user.phone,
		},
		user_errors: false,
		showFormErrors:false,
		is_valid:true,
	});
	
	const userForm = (user, is_valid) => {
		dispatch({ type:'SET_USER_FORM', user, is_valid });
	};

	const changeUser = (k, v) => {
		dispatch({ type:'CHANGE_USER', k, v });
	};

	const has_toc = ((promotion.toc != undefined && promotion.toc != "") || (promotion.external_toc_url != undefined && promotion.external_toc_url != ""));
	const has_policy = ((promotion.policy != undefined && promotion.policy != "") || (promotion.external_policy_url != undefined && promotion.external_policy_url != ""));

	const submitClaim = (cb) => {
		let has_errors = false;
		if(has_toc && state.user.toc == undefined) {
			dispatch({ type:'SET_USER_ERROR', k:'toc', v:"This field cannot be left empty" });
			has_errors = true;
		}
		
		if(has_policy && state.user.policy == undefined) {
			dispatch({ type:'SET_USER_ERROR', k:'policy', v:"This field cannot be left empty" });
			has_errors = true;
		}

		const mandatory = ['email','first_name','last_name'];
		mandatory.map(field=>{
			if (state.user[field] == "" || state.user[field] == null) {
				dispatch({ type:'SET_USER_ERROR', k:field, v:"This field cannot be left empty" });
				has_errors = true;
			}
		})

		if(!state.is_valid) {
			has_errors = true;
		}

		if(has_errors) {
			dispatch({type:'SHOW_ERRORS'});
			if(cb != undefined) cb();
			return;
		}

		let data = {
			claim:JSON.stringify(state.form),
			user:JSON.stringify(state.user),
		};
		
		$.post(window.location.href, data, (response) => {
			dispatch({type:'SET_CLAIMED'});
			if(cb != undefined) cb();
		}, 'JSON');
	};

	let claim_description = "";
	const claim_image = (promotion.full_claim_image != undefined && promotion.full_claim_image != "") ? promotion.full_claim_image : false;
	const default_claim_description = `<h1><strong>You won a {prize}!</strong></h1><p>${i18n("Fill in this form to claim your prize.")}</p>`;

	claim_description = props.intl.formatMessage({ id:promotion?.claim_description || default_claim_description }, { prize:prize_type.title });

	const [ display_toc_layer, setDisplayTocLayer ] = useState(false);
	const [ display_policy_layer, setDisplayPolicyLayer ] = useState(false);

	if(state.status == 'claimed') {
		claim_description = `<h1><strong>${i18n("This prize is already claimed.")}</strong></h1>`;

		return (
			<Wrapper
				image={claim_image}
				description={claim_description}
			/>
		)
	}

	if(state.status == 'thanks') {
		claim_description = `<h1><strong>${i18n("Thank you!")}</strong></h1><p>${i18n("We'll get in touch with you as soon as possible.")}</p>`;

		const display_instructions = (isNotEmpty(prize_type, 'instructions')) ? true : false;

		return (
			<Wrapper
				image={claim_image}
				description={claim_description}
			>
				{(display_instructions) && (
					<div
						class="legal_text mod_align_left gui_main_text_color_on_bg gui_text_block"
						dangerouslySetInnerHTML={{
							__html:prize_type.instructions.replace('\n', '<br />'),
						}}
					/>
				)}
			</Wrapper>
		)
	}	

	let toc_label = false;
	if(has_toc) {
		let toc_link = null;
		if(promotion.external_toc_url != undefined && promotion.external_toc_url != '') {
			toc_link = <ActionLink _href={promotion.external_toc_url} _target="_blank">Terms and conditions</ActionLink>;
		} else {
			toc_link = <ActionLink onClick={() => setDisplayTocLayer(!display_toc_layer)}>Terms and conditions</ActionLink>;
		}

		let toc_label_raw = promotion?.custom_labels?.toc_label ?? "";
		if(toc_label_raw == "") toc_label_raw = "I have read and accept the {toc}.";
		toc_label = <FormattedMessage id={i18n(toc_label_raw.replace("%s", "{toc}"))} values={{ toc:toc_link }} />;
	}

	let policy_label = false;
	if(has_policy) {
		let policy_link = null;
		if(promotion.external_policy_url != undefined && promotion.external_policy_url != '') {
			policy_link = <ActionLink _href={promotion.external_policy_url} _target="_blank">Privacy policy</ActionLink>;
		} else {
			policy_link = <ActionLink onClick={() => setDisplayPolicyLayer(!display_policy_layer)}>Privacy policy</ActionLink>;
		}

		let policy_label_raw = promotion?.custom_labels?.policy_label ?? "";
		if(policy_label_raw == "") policy_label_raw = "***I have read and accept the {policy}.";
		policy_label = <FormattedMessage id={i18n(policy_label_raw.replace("%s", "{policy}"))} values={{ policy:policy_link }} />
	}

	const generic_toc_link = `https://${window.domain_url}/promo_terms/${promotion.id}`;
	const generic_policy_link = `https://${window.domain_url}/policy/${promotion.id}`;
	const submit_label = (promotion.claim_button_label != undefined && promotion.claim_button_label != "") ? promotion.claim_button_label : "Submit";

	return (
		<Wrapper description={claim_description} image={claim_image}>
			<Model
				classname="gui_form_register template_module gui_main_text_color_on_bg"
				model={state.user}
				change={changeUser}
				errors={state.user_errors}
			>
				<Input
					disabled={true}
					name="first_name"
					_field_class='is_2_columned'
					label_props={{
						mandatory:true,
					}}
				>First name</Input>

				<Input
					disabled={true}
					name="last_name"
					_field_class='is_2_columned'
					label_props={{
						mandatory:true,
					}}
				>Last name</Input>

				<EmailField
					disabled={user.email != "" && user.email != null}
					name="email"
					label_props={{
						mandatory:true,
					}}
				>Email</EmailField>

				<PhoneField
					disabled={user.phone != ""}
					name="phone"
					avail_countries={props?.avail_countries ?? ['ca']}
					label_props={{
						mandatory:true,
					}}
				>Telephone</PhoneField>
			</Model>
		
			{(promotion.claim_form) && (
				<DynamicForm
					public_form={true}
					form={promotion.claim_form}
					onChange={userForm}
					user={props.claim?.PromoClaim?.claim_data}
					showFormErrors={state.showFormErrors}
					loc={props.loc}
					model_classes="gui_form_register template_module gui_main_text_color_on_bg"
				/>
			)}

			{(prize_type.claim_form != undefined && prize_type.claim_form != '[]') && (
				<DynamicForm
					public_form={true}
					form={JSON.parse(prize_type.claim_form)}
					onChange={userForm}
					showFormErrors={state.showFormErrors}
					user={props.claim?.PromoClaim?.claim_data}
					loc={props.loc}
					model_classes="gui_form_register template_module gui_main_text_color_on_bg"
				/>
			)}

			<Model
				classname="gui_form_register template_module gui_main_text_color_on_bg"
				model={state.user}
				errors={state.user_errors}
				change={changeUser}
			>
				{(has_toc) && (
					<Checkbox
						name="toc"
					>{toc_label}</Checkbox>
				)}

				{(has_policy) && (
					<Checkbox
						name="policy"
					>{policy_label}</Checkbox>
				)}
			</Model>

			<div class="template_module mod_align_center register_call_to_action_flex is_react_cta">
				<div class="finalize_form enter flex_button gui_big_button">
					<SaveButton
						_fullclass=""
						onClick={(e, cb) => submitClaim(cb)}
					>{submit_label}</SaveButton>
				</div>
			</div>

			{(promotion.disclaimer != undefined && promotion.disclaimer != "") && (
				<div class="legal_text mod_align_left gui_main_text_color_on_bg gui_text_block" dangerouslySetInnerHTML={{ __html:promotion.disclaimer.replace('\n', "<br />")}} />
			)}

			{(display_toc_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Terms and conditions")}</h1>`}
					backButton={() => setDisplayTocLayer(false)}
				>
					<div dangerouslySetInnerHTML={{ __html:promotion.toc.replace(/\n/g, '<br />') }} />

					<ul class="related_link original_color_item">
						<li class="link"><ActionLink _href={generic_toc_link} _target="_blank" _class={{other:'toc_link'}} autotranslate={false}>{generic_toc_link}</ActionLink></li>
					</ul>
				</FloatingLayerPublic>
			)}

			{(display_policy_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Privacy policy")}</h1>`}
					backButton={() => setDisplayPolicyLayer(false)}
				>
					<div dangerouslySetInnerHTML={{ __html:promotion.policy.replace(/\n/g, '<br />') }} />

					<ul class="related_link original_color_item">
						<li class="link"><ActionLink _href={generic_policy_link} _target="_blank" _class={{other:'toc_link'}} autotranslate={false}>{generic_policy_link}</ActionLink></li>
					</ul>
				</FloatingLayerPublic>
			)}
		</Wrapper>
	)
}

export default injectIntl(ClaimPromoLive);